import { Injectable } from "@angular/core";
import { WebCompany, CompanyClient, UtilityClient, WebSettings } from "../models";
import { BehaviorSubject, Observable, ReplaySubject } from "rxjs";
import { Title } from "@angular/platform-browser";
import { SharedService } from "./shared.service";
import { CustomerService } from "./customer.service"
import { filter, switchMap, take } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class CompanyService
{
  public companySubject: ReplaySubject<WebCompany> =
    new ReplaySubject<WebCompany>(1);
  public company: Observable<WebCompany> = this.companySubject.asObservable();

  private webSettingsSubject: ReplaySubject<WebSettings> = new ReplaySubject<WebSettings>(1);
  public webSettings: Observable<WebSettings> = this.webSettingsSubject.asObservable();

  private isNewSearchAvailableSubject = new BehaviorSubject<boolean | null>(null);
  public isNewSearchAvailable$ = this.isNewSearchAvailableSubject.asObservable().pipe(filter((val): val is boolean => val !== null));

  private versionFDS: number = 0;
  companyName: string;
  isAutopayAvailable: boolean;
  isNewSearchAvailable: boolean;
  isCustomerCommentAvailable: boolean;

  constructor(
    private companyClient: CompanyClient,
    private customerService: CustomerService,
    private titleService: Title,
    private sharedService: SharedService,
    private utilityClient: UtilityClient
  )
  {
    this.getCompanyName();
    this.getCompany();
  }

  private getCompany()
  {
    this.sharedService.dataLogical
      .subscribe(s =>
      {
        this.getWebFeaturesAvailability(s);

        const userInfo = sessionStorage.getItem("userInfo");

        if (userInfo !== null)
        {
          this.customerService.customer
            .pipe(switchMap(customer =>
              this.companyClient.getWebCompany(customer.RunCode))).subscribe(company =>
              {
                this.updateCompanyInfo(company, s);
              });
        }
        else
        {
          this.companyClient.getWebCompanyUnauth(s)
            .subscribe(company =>
            {
              this.updateCompanyInfo(company, s);
            });
        }
      });
  }


  private updateCompanyInfo(company: WebCompany, dataLogical: string)
  {
    this.companySubject.next(company);
    this.titleService.setTitle(company.Name);
    this.versionFDS = company.VersionInt;
    this.companyName = company.Name;
    this.setTheme(company.BranchNo, dataLogical);
    sessionStorage.setItem("companyName", company.Name);
    this.isAutopayAvailable = company.WebApsSignUpAvailable ?? false;
  }

  private getCompanyName()
  {
    this.companyName = sessionStorage.getItem("companyName")
      ? sessionStorage.getItem("companyName")
      : this.companyName;
  }

  public getWebFeaturesAvailability(dataLogical)
  {
    this.utilityClient.getWebFeatureAvailability(dataLogical).subscribe(r =>
    {
      if (r)
      {
        this.isCustomerCommentAvailable = r.IsCustomerCommentAvailable;
        this.isNewSearchAvailableSubject.next(r.IsNewCustomerSearchAvailable);
      }
    });
  }

  private setTheme(branchNo: number, datalogical: string): void
  {
    let bn: string = "    ";
    if (this.versionFDS > 10000000)
    {
      if (branchNo > 0)
      {
        bn = `B${ branchNo.toString().padStart(3, "0") }`;
      } 
      else
      {
        bn = "A000";
      }
    }
    this.utilityClient.getWebSettings(bn, datalogical).subscribe((s) =>
    {
      if (s)
      {
        this.sharedService.setDefaultTheme(s.ThemeName);
        this.webSettingsSubject.next(s);
      }
    });
  }
}
